import React from "react";
import "../styles/App.css";

function Projects() {
  return (
    <section className="projects" id="projects">
      <h2>Projects</h2>
      <div className="projects-grid">


        {/* <div className="project-card">
          <h3>Wifinity</h3>
          <p> DESC: control home/office appliances, such as on/off lights, fan <br/> FEATURE: measure your elctricity bills how much if lights turn on it takes cost, scheduler(lights automatically turn at specific time and at specific time set dimming level), 2way – 2 fan on at one time</p>
        </div>

          <div className="project-card">
          <h3>Jade Residency</h3>
          <p>Water level monitoring: from reserve tank water pass 
          to towers P, Q, R, S tanks  
          • If tank is empty fill, it otherwise it already filled then off 
          the flush.</p>
        </div>

        

        <div className="project-card">
          <h3>SNRAS System</h3>
          <p>Use to monitor pH, tds sensors hardware data and that's display on software.</p>
        </div>
        <div className="project-card">
          <h3>Ravima Care</h3>
          <p>Property management system for residents.</p>
        </div>



        <div className="project-card">
          <h3>Lift-Management</h3>
          <p>Automatically using software lift will come at floor.</p>
        </div>

        <div className="project-card">
          <h3>Wifinity Testing - Production & Service</h3>
          <p> To automate your day-to-day tasks. its like support dashboard for main wifinity. </p>
        </div>
      

        
        <div className="project-card">
          <h3>Online Shopping Application</h3>
          <p>Developed to buy products online.</p>
        </div>





        <div className="project-card">
          <h3> E-governance system for property registration and Taxation using blockchain </h3>
          <p>Implemented a secured and transparent transaction 
system </p>
        </div>
       
     
        <div className="project-card">
          <h3>🍊Orange Project</h3>
          <p>................</p>
        </div>

        <div className="project-card">
          <h3>30+ projects And list goes on</h3>
          <p>................</p>
        </div> */}











<div className="project-card">
  <h3 style={{ color: "#007bff" }}>WIFINITY</h3>
  <p>
    <strong>Description:</strong> Control home/office appliances such as lights and fans.<br /><br />
    <strong>Tech Stack:</strong> React, Node, MQTT, REST API, Java, Firebase, GCP, MySQL<br /><br />
    <strong>Features:</strong><br />
    • Available for Android, IOS, Web <br />
    • Measure electricity consumption and calculate billing cost based on usage.<br />
    • Scheduler: Automatically turn lights on/off at specific times and set dimming levels.<br />
    • Two-way control: Operate two fans simultaneously.
  </p>
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>JADE RESIDENCY</h3>
  <p>
    <strong>Description:</strong> Water level monitoring system.<br /><br />
    Water is transferred from the reserve tank to Towers P, Q, R, and S tanks.<br />
    • If a tank is empty, it automatically fills.<br />
    • If the tank is full, the motor/flow automatically stops.
  </p>
   <strong>Tech Stack:</strong> React, Node, MQTT, Flutter, Firebase<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>SNRAS SYSTEM</h3>
  <p>
    <strong>Description:</strong> Monitors pH and TDS sensor hardware data and displays it on a software dashboard in real time.
  </p>
  <strong>Tech Stack:</strong> React, Node, MQTT, Flutter<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>RAVIMA CARE</h3>
  <p>
    <strong>Description:</strong> A property management system designed for residents to manage property-related activities efficiently.
  </p>
  <strong>Tech Stack:</strong> React, Node, Flutter, .net, Grpc, Postgres<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>LIFT-MANAGEMENT</h3>
  <p>
    <strong>Description:</strong> A software-based lift control system that automatically calls and manages lift operations for specific floors.
  </p>
  <strong>Tech Stack:</strong> React, Node, MQTT, Flutter, REST API<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>WIFINITY TESTING – Production & Service</h3>
  <p>
    <strong>Description:</strong> A support and service dashboard developed to automate daily operational tasks for the main Wifinity system.
  </p>
  <strong>Tech Stack:</strong> React, Node, MQTT Protocol, REST API, Web Sockets, Firebase, GCP, MySQL<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>ONLINE SHOPPING APPLICATION</h3>
  <p>
    <strong>Description:</strong> An e-commerce application developed for users to browse and purchase products online.
  </p>
  <strong>Tech Stack:</strong> React, Node, REST API, Postgres<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>
    E-GOVERNANCE SYSTEM FOR PROPERTY REGISTRATION AND TAXATION USING BLOCKCHAIN
  </h3>
  <p>
    <strong>Description:</strong> Implemented a secure and transparent transaction system for property registration and taxation using blockchain technology.
  </p>
  <strong>Tech Stack:</strong> React, Node, Java, Springboot, Thymeleaf, MySQL, Clever cloud, SMTP<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>🍊 AGRICULTURAL ORANGE PROJECT</h3>
  <p>
    <strong>Description:</strong> Confidential internal project (details available upon request).
  </p>
  <strong>Tech Stack:</strong> HTML, CSS, JS, Node, express, REST API<br /><br />
</div>

<div className="project-card">
  <h3 style={{ color: "#007bff" }}>30+ PROJECTS — AND THE LIST GOES ON</h3>
  <p>
    Worked on 30+ real-world projects involving IoT systems, dashboards, automation tools, and full-stack web applications.
  </p>
</div>












      </div> 
      
    </section>
  );
}

export default Projects;
